import { createSelector } from '@reduxjs/toolkit'

import { isAvailableFeatureSelector } from 'features/billing'

const sliceSelector = (state) => state.inviteFlow

export const stepsSelector = createSelector(sliceSelector, ({ steps }) => steps)

export const currentStepIndexSelector = createSelector(
  sliceSelector,
  ({ currentStepIndex }) => currentStepIndex
)

export const isNextStepLoadingSelector = createSelector(
  sliceSelector,
  ({ isNextStepLoading }) => isNextStepLoading
)

export const formSelector = createSelector(
  sliceSelector,
  ({ form }) => form
)

export const currentStepSelector = createSelector(
  currentStepIndexSelector,
  stepsSelector,
  (currentStepIndex, steps) => steps[currentStepIndex]
)

export const nextStepSelector = createSelector(
  currentStepIndexSelector,
  stepsSelector,
  (currentStepIndex, steps) => {
    const nextIndex = currentStepIndex + 1

    if (nextIndex >= steps.length) return null
    return steps[nextIndex]
  }
)

export const previousStepSelector = createSelector(
  currentStepIndexSelector,
  stepsSelector,
  (currentStepIndex, steps) => {
    const previousIndex = currentStepIndex - 1

    if (previousIndex < 0) return null
    return steps[previousIndex]
  }
)

export const isSendInvitationStepSelector = createSelector(
  currentStepIndexSelector,
  stepsSelector,
  (currentStepIndex, steps) => currentStepIndex === (steps.length - 2)
)

export const userGroupsSelector = createSelector(
  sliceSelector,
  ({ userGroups }) => userGroups.list
)

export const anyGroupsSelector = createSelector(
  sliceSelector,
  ({ userGroups }) => userGroups.anyGroups
)

export const userGroupsLoadingSelector = createSelector(
  sliceSelector,
  ({ userGroups }) => userGroups.isLoading
)

export const selectedGroupSelector = createSelector(
  sliceSelector,
  ({ userGroups }) => userGroups.selected
)

export const selectedGroupNameSelector = createSelector(
  selectedGroupSelector,
  (selectedGroup) => selectedGroup && selectedGroup.name
)

export const selectedGroupIdSelector = createSelector(
  sliceSelector,
  ({ userGroups }) => userGroups.selected && userGroups.selected.id
)

const managedEventTypesSelector = createSelector(
  sliceSelector,
  ({ managedEventTypes }) => managedEventTypes
)

export const managedEventTypesListSelector = createSelector(
  managedEventTypesSelector,
  ({ list }) => list
)

export const isManagedEventTypesLoadingSelector = createSelector(
  managedEventTypesSelector,
  ({ isLoading }) => isLoading
)

export const managedEventTypesSortOrderSelector = createSelector(
  managedEventTypesSelector,
  ({ sortOrder }) => sortOrder
)

export const managedEventTypesPaginationSelector = createSelector(
  managedEventTypesSelector,
  ({ pagination }) => pagination
)

export const isUserGroupsFeatureEnabledSelector = (state) => isAvailableFeatureSelector(
  state, { featureKey: 'user_groups' }
)

export const recaptchaCallbackSelector = createSelector(
  sliceSelector,
  ({ recaptcha: { callback } }) => callback
)

export const showRecaptchaChallengeSelector = createSelector(
  sliceSelector,
  ({ recaptcha }) => recaptcha?.showChallenge ?? false
)

export const recaptchaV2TokenSelector = createSelector(
  sliceSelector,
  ({ recaptcha }) => recaptcha?.v2Token
)

export const errorsSelector = createSelector(
  sliceSelector,
  ({ errors }) => errors
)

export const roleSelector = createSelector(
  sliceSelector,
  ({ role }) => role
)

export const modalSuccessSelector = createSelector(
  sliceSelector,
  ({ modal: { success } }) => success
)

export const addUsersModalOpenSelector = createSelector(
  sliceSelector,
  ({ modal: { open } }) => open
)

export const isMfaOpenSelector = createSelector(
  sliceSelector,
  ({ mfa }) => mfa.open
)
